import script from "./cookie-consent-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./cookie-consent-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__